import React from "react";

export default function LegalDisclaimerPage() {
  // Simple breadcrumb navigation
  const breadcrumbs = [
    { label: "Home", path: "/" },
    { label: "Legal Disclaimer", path: null }, // Current page
  ];

  return (
    <div className="min-h-screen bg-[#F2F4F8]">
      <div className="container mx-auto px-4 lg:px-6 py-8 pt-24 lg:py-12 lg:pt-28">
        {/* BREADCRUMB */}
        {/* <nav className="text-xs sm:text-sm text-gray-500 mb-6">
          {breadcrumbs.map((item, idx) => {
            const isLast = idx === breadcrumbs.length - 1;
            return (
              <span key={item.label}>
                {!isLast ? (
                  <>
                    <a
                      href={item.path}
                      className="cursor-pointer hover:underline hover:text-gray-700 transition-colors"
                    >
                      {item.label}
                    </a>
                    <span className="mx-1.5 text-gray-400">/</span>
                  </>
                ) : (
                  <span className="text-gray-700 font-medium">
                    {item.label}
                  </span>
                )}
              </span>
            );
          })}
        </nav> */}

        {/* PAGE TITLE */}
        <h1 className="text-2xl max-w-xl text-center mx-auto sm:text-3xl font-semibold text-gray-900 mb-6">
          LEGAL DISCLAIMER FOR ACTIVATION OF AUTOMATED TRADING BOT
        </h1>

        {/* MAIN CONTENT CARD */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 sm:p-10">
          {/* HEADER / INTRO */}
          <div className="mb-5 border-b border-gray-100 ">
            {/* <h2 className="text-xl font-bold text-gray-900 mb-4">
              LEGAL DISCLAIMER FOR ACTIVATION OF AUTOMATED TRADING BOT
            </h2> */}
            <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
              By activating, accessing, or utilizing the automated trading bot
              (the “Bot”) provided by Xenorize (“Company”), you hereby
              acknowledge and agree to the following terms. This Disclaimer
              forms a binding part of the User Agreement between you (“User”)
              and the Company. If you do not agree to any provision herein, you
              must not activate or use the Bot.
            </p>
          </div>

          {/* LEGAL SECTIONS */}
          <div className="space-y-8 text-gray-700 text-sm sm:text-base leading-relaxed">
            {/* Section 1 */}
            <section className="!pb-0">
              <h3 className="font-bold text-gray-900 mb-3">
                1. No Financial, Investment, or Professional Advice
              </h3>
              <div className="space-y-2 pl-2">
                <p>1.1 The Bot is provided solely as an automation tool.</p>
                <p>
                  1.2 The Company does not provide financial, investment,
                  trading, legal, accounting, or tax advice of any kind.
                </p>
                <p>
                  1.3 All decisions to use this bot and to choose the pair to be
                  traded are made independently by the User.
                </p>
                <p>
                  1.4 The User acknowledges that use of the Bot does not create
                  any fiduciary relationship between the User and the Company.
                </p>
              </div>
            </section>

            {/* Section 2 */}
            <section className="!pb-0">
              <h3 className="font-bold text-gray-900 mb-3">
                2. Risk Acknowledgment
              </h3>
              <div className="space-y-2 pl-2">
                <p>
                  2.1 The User understands and expressly accepts that trading in
                  digital assets involves substantial risk, including but not
                  limited to high market volatility, regulatory changes, and the
                  risk of certain loss of capital depending on the market
                  condition.
                </p>
                <p>
                  2.2 The Company makes no guarantees or representations
                  regarding profitability, performance, or specific outcomes
                  from use of the Bot.
                </p>
                <p>
                  2.3 Past performance, hypothetical results, backtesting data,
                  or examples are not indicative of future results.
                </p>
              </div>
            </section>

            {/* Section 3 */}
            <section className="!pb-0">
              <h3 className="font-bold text-gray-900 mb-3">
                3. User Responsibility
              </h3>
              <div className="space-y-2 pl-2">
                <p>3.1 The User is solely responsible for:</p>
                <ul className="list-disc pl-6 space-y-1 text-gray-600">
                  <li>choosing strategies, settings, and risk parameters;</li>
                  <li>monitoring their trading account and Bot performance;</li>
                  <li>maintaining sufficient balance;</li>
                  <li>understanding how the Bot operates;</li>
                  <li>
                    ensuring the accuracy and security of exchange API keys.
                  </li>
                </ul>
                <p className="mt-2">
                  3.2 The Company shall not be responsible for any consequences
                  arising from the User’s failure to properly configure or
                  supervise the Bot.
                </p>
              </div>
            </section>

            {/* Section 4 */}
            <section className="!pb-0">
              <h3 className="font-bold text-gray-900 mb-3">4. No Liability</h3>
              <div className="space-y-2 pl-2">
                <p>
                  4.1 To the maximum extent permitted by applicable law, the
                  Company, its officers, employees, agents, affiliates, and
                  partners shall not be liable for any direct, indirect,
                  incidental, consequential, exemplary, punitive, or special
                  damages arising out of or in connection with:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-gray-600">
                  <li>market losses or adverse price movements;</li>
                  <li>
                    exchange downtime, failure, delay, or security breaches;
                  </li>
                  <li>third-party API malfunctions;</li>
                  <li>
                    errors, bugs, or interruptions in the Bot or related
                    systems;
                  </li>
                  <li>the User’s use, misuse, or inability to use the Bot.</li>
                </ul>
                <p className="mt-2">
                  4.2 The User accepts full financial risk associated with
                  activating and operating the Bot.
                </p>
              </div>
            </section>

            {/* Section 5 */}
            <section className="!pb-0">
              <h3 className="font-bold text-gray-900 mb-3">
                5. Third-Party Platforms and API Integration
              </h3>
              <div className="space-y-2 pl-2">
                <p>
                  5.1 The Bot operates by connecting to third-party
                  cryptocurrency exchanges via API access provided by the User.
                </p>
                <p>
                  5.2 The Company does not control and is not responsible for
                  the actions, security practices, policies, or performance of
                  any third-party exchange.
                </p>
                <p>
                  5.3 The User is solely responsible for complying with all
                  exchange terms of service.
                </p>
              </div>
            </section>

            {/* Section 6 */}
            <section className="!pb-0">
              <h3 className="font-bold text-gray-900 mb-3">
                6. Regulatory and Tax Compliance
              </h3>
              <div className="space-y-2 pl-2">
                <p>
                  6.1 The User is solely responsible for complying with all
                  applicable laws and regulations in their jurisdiction,
                  including but not limited to tax reporting, trading
                  permissions, and regulatory requirements.
                </p>
                <p>
                  6.2 The Company does not make any representation as to the
                  legal status of cryptocurrency trading within any
                  jurisdiction.
                </p>
              </div>
            </section>

            {/* Section 7 */}
            <section className="!pb-0">
              <h3 className="font-bold text-gray-900 mb-3">
                7. Assumption of Risk and Consent
              </h3>
              <div className="space-y-2 pl-2">
                <p>7.1 By activating the Bot, the User confirms that they:</p>
                <ul className="list-disc pl-6 space-y-1 text-gray-600">
                  <li>have read and understood this Legal Disclaimer;</li>
                  <li>
                    understand the inherent financial risks of automated
                    trading;
                  </li>
                  <li>voluntarily choose to proceed;</li>
                  <li>assume full responsibility for all outcomes.</li>
                </ul>
                <p className="mt-2">
                  7.2 Activation of the Bot constitutes the User’s legally
                  binding acceptance of all provisions contained herein.
                </p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
